// test: yarn test src/utils/__tests__/StringVariableParser.spec.js
import moment from 'moment';
import _ from 'lodash';

export default class StringVariableParser {
  constructor() {
    const getBirthdayPart = (context, key) => {
      const birthday = context.customer?.birthday;
      if (!birthday) return null;

      const m = moment(birthday);
      if (m.isValid()) {
        if (key === 'birthday_year') return m.format('YYYY');
        if (key === 'birthday_month') return m.format('MM');
        if (key === 'birthday_day') return m.format('DD');
      }
      return null;
    };

    this.rules = {
      "$customer['extra']['field']": {
        regex: /\{\{\s*\$customer\s*\[['"]extra['"]\]\s*\[['"](.+?)['"]\]\s*\}\}/g,
        callback: (match, key, context) => _.get(context.customer, ['extra', key], "")
      },
      "$customer['field']": {
        regex: /\{\{\s*\$customer\s*\[['"](.+?)['"]\]\s*\}\}/g,
        callback: (match, key, context) => {
          const birthdayPart = getBirthdayPart(context, key);
          if (birthdayPart !== null) return birthdayPart;
          return _.get(context.customer, key, "");
        }
      },
      "$customer.field": {
        regex: /\{\{\s*\$customer\.([\w.]+)\s*\}\}/g,
        callback: (match, pathStr, context) => {
          const birthdayPart = getBirthdayPart(context, pathStr);
          if (birthdayPart !== null) return birthdayPart;
          return _.get(context.customer, pathStr, "");
        },
      },
    };
  }

  parse(template, context) {
    let result = template;
    for (const key in this.rules) {
      const { regex, callback } = this.rules[key];
      result = result.replace(regex, (match, p1) => callback(match, p1, context));
    }
    return result;
  }

  register(key, regex, callback) {
    this.rules[key] = { regex, callback };
    return this;
  }
}
